import type { CommSrvTime } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import type { FormatNumberOptions } from 'react-intl';

export { initModuleNativeClient } from './nativeClient';
export { stripHTML } from './stripHTML';
export { calculateCurrencyAmount } from './calculateCurrencyAmount';
export { parseHSPCriteria, criteriaMatches } from './HSPCriteria';
export { mustNotContainSymbols, mustBeLowerOrEqual, mustBeBiggerOrEqual } from './validators';
export { handleServerError, handleServerResponse } from './serverResponse';
export { default as generateGameUrl } from './generateGameUrl';
export { formatMTTournamentAttr } from './MTT/tournaments';
export { generateAvatarGraphics } from './generateAvatarGraphics';
export { default as getTimeDiff } from './getTimeDiff';
export { getSafeMilliseconds } from './getSafeMilliseconds';
export { formatTournamentAttr } from './tournaments';
export {
  default as getTimeFormatProps,
  getTimeFormatPropsFromTimeDiff
} from './tournaments/getTimeFormatProps';
// TODO: change this
export * from './MTT';

export const getFormatOptionsRM = (
  isPlayMoney: boolean,
  currency?: string
): FormatNumberOptions => ({
  style: isPlayMoney ? 'decimal' : 'currency',
  currency,
  currencyDisplay: 'narrowSymbol',
  currencySign: 'standard',
  minimumFractionDigits: isPlayMoney ? 0 : 2,
  maximumFractionDigits: isPlayMoney ? 0 : 2
});

export function parseCommlibDate({ day, hour, minute, month, second, year }: CommSrvTime) {
  return new Date(
    Number(year),
    Number(month),
    Number(day),
    Number(hour),
    Number(minute),
    Number(second)
  );
}
